import { render, staticRenderFns } from "./AgreementCheckboxes.vue?vue&type=template&id=6bde101c"
import script from "./AgreementCheckboxes.vue?vue&type=script&lang=js"
export * from "./AgreementCheckboxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports